import { render, staticRenderFns } from "./OrderLogDrawer.vue?vue&type=template&id=38a06042"
import script from "./OrderLogDrawer.vue?vue&type=script&lang=js"
export * from "./OrderLogDrawer.vue?vue&type=script&lang=js"
import style0 from "./OrderLogDrawer.vue?vue&type=style&index=0&id=38a06042&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38a06042')) {
      api.createRecord('38a06042', component.options)
    } else {
      api.reload('38a06042', component.options)
    }
    module.hot.accept("./OrderLogDrawer.vue?vue&type=template&id=38a06042", function () {
      api.rerender('38a06042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/orderLogs/OrderLogDrawer.vue"
export default component.exports